import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../../services/apiamrg'
import Header from '../../../components/header'
import Rodape from '../../../components/rodape'
import loader from '../../../classes/loader'
import Skeleton from '../../../components/skeleton'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { NOME_EMPRESA } from '../../../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faTrashAlt, faPen, faPlus, faChevronDown, faChevronUp,
    faDollarSign, faExclamationTriangle   // ADICIONAR estes
} from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from 'react-confirm-alert'
import AddButton from '../../../components/addButton';
import 'react-confirm-alert/src/react-confirm-alert.css'
import moment from 'moment'
import ModalEdit from '../../../components/modalEdit'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { Formik, Field, Form } from 'formik'

const estadoInicial = {
    name: '',
    contas: [],
    pesquisa: "",
    tipoPesquisa: 1,
    pessoas: '',

    deleteConta: false,

    loading: true,
    redirect: false,

    acessos: [],
    permissoes: [],
    acessosPermissoes: [],
    direcaoTabela: faChevronDown,

    editValor: '0',
    editChave: '0',
    editSaldo: '0',
    itemNome: '',
    modalItemAberto: false,
    itemPermissao: 'CONTAS_ABERTAS',
    itemEdit: {
    },

    modalRecebimento: false,
    recChave: 0,
    recHistorico: '',
    recSaldo: 0,
    recValor: '',
    recData: moment().format('YYYY-MM-DD'),
    recBloqueado: false,

    recBloqueado: false,
    planosContasOptions: [],
    recContaContabil: '',
    load: 100
}

class ContasReceber extends Component {

    state = {
        ...estadoInicial,
        usuarioLogado: this.props.user
    }

    // ADICIONAR estas funções na classe ContasReceber:

    abrirRecebimento = (feed) => {
        this.setState({
            modalRecebimento: true,
            recChave: feed.Chave,
            recHistorico: feed.Historico || feed.pessoaNome,
            recSaldo: feed.SaldoBRL,
            recSaldoOriginal: feed.Saldo,
            recValor: '',
            recData: moment().format('YYYY-MM-DD'),
            recContaContabil: (!feed.Conta_Contabil || feed.Conta_Contabil === "0") ? '' : feed.Conta_Contabil, // ← ATRIBUIR CONTA
            recBloqueado: false,
        })
    }

    receberConta = async (validForm) => {
        if (!validForm) return;
        this.setState({ recBloqueado: true, loading: true });

        const valorBRL = parseFloat(
            this.state.recValor.replaceAll('.', '').replaceAll(',', '.')
        );

        const roe = this.state.recSaldoOriginal && this.state.recSaldoOriginal > 0
            ? (this.state.recSaldo / this.state.recSaldoOriginal)
            : 1;

        const valorOriginal = valorBRL / roe;
        const novoSaldoOriginal = this.state.recSaldoOriginal - valorOriginal;

        await apiEmployee.post(`fazerBaixaConta.php`, {
            token: true,
            chave: this.state.recChave,
            saldo: novoSaldoOriginal >= 0 ? novoSaldoOriginal : 0,
            recebimento: valorOriginal,
            data_pagto: this.state.recData,
            conta_contabil: this.state.recContaContabil
        }).then(
            async res => {
                if (res.data !== 'false') {
                    await loader.salvaLogs('contas_aberto',
                        this.state.usuarioLogado.codigo, null,
                        `Saldo (de)${this.state.recSaldoOriginal} (para)${novoSaldoOriginal >= 0 ? novoSaldoOriginal : 0}; ` +
                        `Data_Recebimento ${this.state.recData}; Valor_Recebido ${valorOriginal};`,
                        this.state.recChave
                    );
                    await this.setState({ modalRecebimento: false, loading: false });
                    await this.loadAll();
                } else {
                    alert('Erro ao receber conta');
                    this.setState({ recBloqueado: false, loading: false });
                }
            },
            async err => {
                console.log(err);
                this.setState({ recBloqueado: false, loading: false });
            }
        );
    }

    componentDidMount = async () => {
        await this.loadAll();
        if (this.state.chaveFocus) {
            if (this.refs.focusMe) {
                await this.refs.focusMe.focus();
            }
        }

        this.state.acessosPermissoes.map((e) => {
            if (e.acessoAcao == "CONTAS_ABERTAS" && e.permissaoConsulta == 0) {
                this.setState({ redirect: true })
            }
        })
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (this.state.deleteConta && this.state.modalItemAberto != prevState.modalItemAberto) {
            await this.setState({
                modalItemAberto: false,
                deleteConta: false
            })
        }
    }

    loadAll = async () => {
        await this.setState({
            contas: await loader.getBase('getContasReceber.php', this.state.usuarioLogado.empresa),
            acessos: await loader.getBase('getTiposAcessos.php'),
            permissoes: await loader.getBase('getPermissoes.php'),
            planosContasOptions: await loader.getPlanosContasAnaliticasOptions(), // ← CARREGAR OPÇÕES
        })

        await this.getPessoas();

        if (this.props.location.state && this.props.location.state.chave) {
            await this.setState({ chaveFocus: this.props.location.state.chave });
        }

        await this.setState({
            acessosPermissoes: await loader.testaAcesso(this.state.acessos, this.state.permissoes, this.state.usuarioLogado),
            loading: false
        })
    }

    getPessoas = async () => {
        await apiEmployee.post(`getPessoas.php`, {
            token: true,
        }).then(
            async response => {
                console.log('=== DEBUG getPessoas Contas a Receber ===');

                await this.setState({ pessoas: response.data })

                // Verificar se a pessoa 100 veio da API
                const pessoa100 = this.state.pessoas.find((el) => el.Chave == 100);
                console.log('1. Pessoa 100 na lista de pessoas:', pessoa100);
                console.log('2. Total de pessoas carregadas:', this.state.pessoas.length);

                // Verificar as contas
                console.log('3. Total de contas:', this.state.contas.length);
                const conta334 = this.state.contas.find(c => c.Chave == 334);
                console.log('4. Conta 334:', conta334);

                if (conta334) {
                    console.log('5. Pessoa da conta 334:', conta334.Pessoa, typeof conta334.Pessoa);

                    // Tentar encontrar de várias formas
                    const find1 = this.state.pessoas.find((el) => el.Chave == conta334.Pessoa);
                    console.log('6. Find com ==:', find1);

                    const find2 = this.state.pessoas.find((el) => String(el.Chave) === String(conta334.Pessoa));
                    console.log('7. Find com String:', find2);

                    const find3 = this.state.pessoas.find((el) => parseInt(el.Chave) === parseInt(conta334.Pessoa));
                    console.log('8. Find com parseInt:', find3);

                    // Listar todas as Chaves de pessoas
                    console.log('9. Chaves das primeiras 10 pessoas:',
                        this.state.pessoas.slice(0, 10).map(p => ({ Chave: p.Chave, tipo: typeof p.Chave })));
                }

                let pessoa = "";
                const contas = this.state.contas.map((e) => {
                    pessoa = this.state.pessoas.find((el) => el.Chave == e.Pessoa);

                    if (e.Chave == 334 || e.Chave == 326) {
                        console.log(`\nConta ${e.Chave}:`);
                        console.log('  Pessoa:', e.Pessoa, typeof e.Pessoa);
                        console.log('  Encontrou:', pessoa ? pessoa.Nome : 'NÃO ENCONTROU');
                    }

                    if (pessoa) {
                        return { ...e, pessoaNome: pessoa.Nome }
                    } else {
                        return { ...e, pessoaNome: '' }
                    }
                })

                await this.setState({ contas: contas })

                // Verificar resultado final
                const conta334Final = this.state.contas.find(c => c.Chave == 334);
                console.log('\n10. Conta 334 final:', conta334Final?.pessoaNome);
            },
            response => { this.erroApi(response) }
        )
    }

    salvarRecebimento = async () => {
        const saldo = this.state.editSaldo - parseFloat(this.state.editValor.replaceAll('.', '').replaceAll(',', '.'))

        this.setState({
            loading: true,
            modalItemAberto: false,
        })
        await apiEmployee.post(`fazerBaixaConta.php`, {
            token: true,
            chave: this.state.editChave,
            saldo: saldo >= 0 ? saldo : 0,
            recebimento: this.state.editValor.replaceAll('.', '').replaceAll(',', '.'),
        }).then(
            res => {
                this.setState({ loading: false });
                this.loadAll();
            },
            error => { this.erroApi(error) }
        )
    }

    setEditModal = async (conta) => {
        const recebimento = parseFloat(conta.received_manual ? conta.received_manual : '0');
        const saldo = parseFloat(conta.Saldo)

        await this.setState({
            editChave: conta.Chave,
            editValor: recebimento,
            editSaldo: saldo,
        });

        await this.setState({
            itemNome: `${conta.os_manual} - saldo atual: R$ ${new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(saldo)}`,
            itemEdit: {
                onSubmit: async () => await this.salvarRecebimento(),
                valores: [
                    {
                        titulo: 'Valor Recebido',
                        valor: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(recebimento),
                        tipo: 'money',
                        onChange: async (valor) => { await this.setState({ editValor: valor }); },
                        onBlur: async (valor) => { await this.setState({ editValor: Number(valor.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor.replaceAll('.', '').replaceAll(',', '.')) : '' }); },
                    }
                ]
            },
            modalItemAberto: true
        })
    }

    fazerBaixa = async (chave, nome) => {
        this.setState({ deleteConta: true })
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <p>Deseja fazer baixa da conta de {nome}? </p>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.post(`fazerBaixaConta.php`, {
                                        token: true,
                                        chave
                                    }).then(
                                        res => {
                                            this.loadAll();
                                        },
                                        error => { this.erroApi(error) }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    erroApi = async (res) => {
        alert(res)
        await this.setState({ redirect: true })
    }

    deleteConta = async (chave, nome) => {
        this.setState({ deleteConta: true })
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <p>Deseja remover a conta de {nome}? </p>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.post(`deleteConta.php`, {
                                        token: true,
                                        chave: chave
                                    }).then(
                                        async response => {
                                            if (response.data == true) {
                                                await loader.salvaLogs('contas_aberto', this.state.usuarioLogado.codigo, null, "Exclusão", chave);

                                                document.location.reload()
                                            }
                                        },
                                        async response => {
                                            this.erroApi(response)
                                        }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    reverterItens = async () => {
        await this.setState({ loading: true })
        const contas = this.state.contas.reverse();

        if (this.state.direcaoTabela == faChevronDown) {
            await this.setState({ direcaoTabela: faChevronUp });
        } else {
            await this.setState({ direcaoTabela: faChevronDown });
        }

        await this.setState({ contas, loading: false });
    }

    filtrarPesquisa = (conta) => {
        const pesquisa = this.state.pesquisa.toLowerCase();

        if (this.state.tipoPesquisa == 1) {
            const pessoa = conta.pessoaNome ? String(conta.pessoaNome).toLowerCase() : '';
            return pessoa.includes(pesquisa);
        } else if (this.state.tipoPesquisa == 2) {
            const valor = conta.Valor ? String(conta.Valor).toLowerCase() : '';
            return valor.includes(pesquisa);
        } else if (this.state.tipoPesquisa == 3) {
            const chave = conta.Chave ? String(conta.Chave).toLowerCase() : '';
            return chave.includes(pesquisa);
        } else if (this.state.tipoPesquisa == 4) {
            const data = conta.Vencimento ? moment(conta.Vencimento).format('DD/MM/YYYY').toLowerCase() : '';
            return data.includes(pesquisa);
        }

        return true;
    }

    render() {

        return (

            <div className='allContent'>

                <div>
                    {this.state.loading &&
                        <Skeleton />
                    }

                    {this.state.redirect &&
                        <Redirect to={'/'} />
                    }

                    {!this.state.loading &&
                        <div>
                            <section>
                                <Header voltarContasAbertas titulo="Contas a Receber" />

                                <Modal
                                    style={{
                                        display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
                                        paddingTop: '5vh', overflow: 'auto'
                                    }}
                                    open={this.state.modalRecebimento}
                                    onClose={() => this.setState({ modalRecebimento: false })}
                                >
                                    <Box sx={{
                                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                        padding: '30px',
                                        borderRadius: '12px',
                                        minWidth: 350,
                                        maxWidth: 500,
                                        width: '90%',
                                        boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                                        border: '1px solid rgba(0,0,0,0.08)'
                                    }}>
                                        <h5 style={{ marginBottom: '8px', color: '#333', fontWeight: 600 }}>
                                            Receber: {this.state.recHistorico}
                                        </h5>
                                        <p style={{ marginBottom: '20px', color: '#666', fontSize: '0.95rem' }}>
                                            Saldo: <span style={{ fontWeight: 600, color: '#28a745' }}>
                                                R$ {new Intl.NumberFormat('pt-BR', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }).format(this.state.recSaldo)}
                                            </span>
                                        </p>
                                        {(() => {
                                            const valor = parseFloat((this.state.recValor || '0').replaceAll('.', '').replaceAll(',', '.'));
                                            const validRec = [
                                                valor > 0,
                                                valor.toFixed(2) === parseFloat(this.state.recSaldo).toFixed(2), // deve ser igual ao saldo
                                                this.state.recData,
                                                this.state.recContaContabil !== '',
                                                !this.state.recBloqueado,
                                            ].reduce((t, a) => t && a);

                                            return (
                                                <Formik initialValues={{}}
                                                    onSubmit={async () => { await this.receberConta(validRec); }}>
                                                    <Form>
                                                        <div className="row" style={{ marginBottom: 15, alignItems: 'center' }}>
                                                            <div className="col-3">
                                                                <label style={{ marginBottom: 0, fontWeight: 500 }}>Valor</label>
                                                            </div>
                                                            <div className="col-1" style={{ textAlign: 'center' }}>
                                                                {this.state.recValor && (isNaN(valor) || valor <= 0 || valor.toFixed(2) !== parseFloat(this.state.recSaldo).toFixed(2)) &&
                                                                    <FontAwesomeIcon title='Valor deve ser igual ao saldo' icon={faExclamationTriangle} color='#ff9800' />
                                                                }
                                                            </div>
                                                            <div className="col-8" style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
                                                                <Field className="form-control text-right" type="text"
                                                                    placeholder="0,00"
                                                                    value={this.state.recValor}
                                                                    style={{ flex: 1 }}
                                                                    onClick={e => e.target.select()}
                                                                    onChange={e => this.setState({ recValor: e.currentTarget.value })}
                                                                    onBlur={e => this.setState({
                                                                        recValor: Number(e.currentTarget.value
                                                                            .replaceAll('.', '').replaceAll(',', '.')) ?
                                                                            new Intl.NumberFormat('pt-BR').format(
                                                                                e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')
                                                                            ) : ''
                                                                    })} />
                                                                <button type="button"
                                                                    onClick={() => this.setState({
                                                                        recValor: new Intl.NumberFormat('pt-BR').format(this.state.recSaldo)
                                                                    })}
                                                                    title="Receber o saldo total"
                                                                    style={{
                                                                        padding: '2px 6px',
                                                                        background: 'transparent',
                                                                        border: 'none',
                                                                        color: '#6c757d',
                                                                        cursor: 'pointer',
                                                                        fontSize: '0.68rem',
                                                                        transition: 'color 0.2s',
                                                                        whiteSpace: 'nowrap',
                                                                        textDecoration: 'none'
                                                                    }}
                                                                    onMouseEnter={e => e.target.style.color = '#495057'}
                                                                    onMouseLeave={e => e.target.style.color = '#6c757d'}
                                                                >
                                                                    Receber tudo
                                                                </button>
                                                            </div>
                                                        </div>



                                                        <div className="row" style={{ marginBottom: 15 }}>
                                                            <div className="col-3">
                                                                <label style={{ marginBottom: 0, fontWeight: 500 }}>Conta Contábil</label>
                                                            </div>
                                                            <div className="col-1" style={{ textAlign: 'center' }}>
                                                                {!this.state.recContaContabil &&
                                                                    <FontAwesomeIcon title='Selecione uma conta' icon={faExclamationTriangle} color='#ff9800' />
                                                                }
                                                            </div>
                                                            <div className="col-8">
                                                                <select
                                                                    className="form-control"
                                                                    value={this.state.recContaContabil}
                                                                    onChange={e => this.setState({ recContaContabil: e.currentTarget.value })}
                                                                >
                                                                    <option value="">Selecione uma conta...</option>
                                                                    {this.state.planosContasOptions.map((opcao, index) => (
                                                                        <option key={index} value={opcao.value}>
                                                                            {opcao.label}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="row" style={{ marginBottom: 25 }}>
                                                            <div className="col-3">
                                                                <label style={{ marginBottom: 0, fontWeight: 500 }}>Data Recebimento</label>
                                                            </div>
                                                            <div className="col-1" style={{ textAlign: 'center' }}>
                                                                {!this.state.recData &&
                                                                    <FontAwesomeIcon title='Preencha a data' icon={faExclamationTriangle} color='#ff9800' />
                                                                }
                                                            </div>
                                                            <div className="col-8">
                                                                <Field className="form-control" type="date"
                                                                    value={this.state.recData}
                                                                    onChange={e => this.setState({ recData: e.currentTarget.value })} />
                                                            </div>
                                                        </div>

                                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                                            <button type="submit"
                                                                className='btn btn-success'
                                                                disabled={!validRec}
                                                                style={validRec ? { width: 150 } : { width: 150, opacity: 0.5, cursor: 'not-allowed' }}>
                                                                Receber
                                                            </button>
                                                            <button type="button"
                                                                onClick={() => this.setState({ modalRecebimento: false })}
                                                                style={{
                                                                    width: 150,
                                                                    padding: '10px 20px',
                                                                    background: '#6c757d',
                                                                    color: '#fff',
                                                                    border: 'none',
                                                                    borderRadius: '6px',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.3s',
                                                                    boxShadow: '0 4px 12px rgba(108, 117, 125, 0.2)'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.background = '#5a6268';
                                                                    e.target.style.boxShadow = '0 6px 16px rgba(108, 117, 125, 0.3)';
                                                                    e.target.style.transform = 'translateY(-2px)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.background = '#6c757d';
                                                                    e.target.style.boxShadow = '0 4px 12px rgba(108, 117, 125, 0.2)';
                                                                    e.target.style.transform = 'translateY(0)';
                                                                }}
                                                            >
                                                                Cancelar
                                                            </button>
                                                        </div>
                                                    </Form>
                                                </Formik>
                                            );
                                        })()}
                                    </Box>
                                </Modal>

                                <br />
                            </section>

                            <ModalEdit
                                closeModal={() => { this.setState({ modalItemAberto: false }) }}
                                nome={this.state.itemNome}
                                modalAberto={this.state.modalItemAberto}
                                itemPermissao={this.state.itemPermissao}
                                acessosPermissoes={this.state.acessosPermissoes}
                                itemEdit={this.state.itemEdit}
                                onSubmit={this.salvarRecebimento}
                                valid={true}
                            />

                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left">
                                <div className="row mobileajuster3">
                                    <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 sumir">
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  text-right pesquisa mobileajuster1 ">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  text-right pesquisa mobileajuster1 ">
                                            <select className="form-control tipoPesquisa col-4 col-sm-4 col-md-3 col-lg-3 col-xl-2" placeholder="Tipo de pesquisa..." value={this.state.tipoPesquisa} onChange={e => { this.setState({ tipoPesquisa: e.currentTarget.value }) }}>
                                                <option value={1}>Pessoa</option>
                                                <option value={2}>Valor</option>
                                                <option value={4}>Vencimento</option>
                                                <option value={3}>Chave</option>
                                            </select>
                                            <input className="form-control campoPesquisa col-7 col-sm-6 col-md-6 col-lg-5 col-xl-5" placeholder="Pesquise aqui..." value={this.state.pesquisa} onChange={e => { this.setState({ pesquisa: e.currentTarget.value }) }} />
                                            <div>
                                                <Link to={{ pathname: `/financeiro/relatorio/`, state: { backTo: 'contasReceber' } }}><button className="btn btn-success">Relatorio</button></Link>
                                            </div>
                                            <div style={{ marginLeft: 15 }}>
                                                <Link to={{
                                                    pathname: `/financeiro/addconta/0`,
                                                    state: { conta: {}, tipo: 0, to: 'contasreceber' }
                                                }}><button className="btn btn-success">+</button></Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-0 col-sm-0 col-md-3 col-lg-3 col-xl-3"></div>
                                    <div>
                                    </div>

                                </div>
                            </div>

                            <AddButton addLink={{
                                pathname: `/financeiro/addconta/0`,
                                state: { conta: {}, tipo: 0, to: 'contasreceber' }
                            }} />

                            <div className="row deleteMargin" id="product-list">
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                                <div className="col-lg-8 col-md-8 col-sm-12 col-12 mix all dresses bags">
                                    <div className="single-product-item" >
                                        <div className="row subtitulosTabela">
                                            <div className="col-1 text-left">
                                                <span className="subtituloships">Id</span>
                                            </div>
                                            <div className="col-3 text-left">
                                                <span className="subtituloships">Pessoa</span>
                                            </div>
                                            <div className="col-2 text-left">
                                                <span className="subtituloships">Vencimento</span>
                                            </div>
                                            <div className="col-2 text-left">
                                                <span className="subtituloships">Valor</span>
                                            </div>
                                            <div className="col-2 text-left">
                                                <span className="subtituloships">Saldo</span>
                                            </div>
                                            <div className="col-2 text-center revertItem" onClick={() => { if (this.state.contas[0]) { this.reverterItens() } }}>
                                                {!this.state.contas[0] && this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'CONTAS_ABERTAS') { return e } }).map((e) => e.permissaoInsere)[0] == 1 &&
                                                    <span className="subtituloships"><Link to={{ pathname: `/financeiro/addconta/0`, state: { tipo: 0, to: 'contasreceber' } }}><FontAwesomeIcon icon={faPlus} /></Link></span>
                                                }
                                                {this.state.contas[0] &&
                                                    <span className="subtituloships"><FontAwesomeIcon icon={this.state.direcaoTabela} /></span>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                            </div>

                            <div id="product-list">
                                {this.state.contas[0] != undefined && this.state.contas.filter(this.filtrarPesquisa).splice(0, this.state.load).map((feed, index) => (
                                    <div key={feed.Chave} className="row row-list">
                                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-0"></div>
                                        <div ref={feed.Chave == this.state.chaveFocus ? "focusMe" : ""} tabindex={-1} className={`col-lg-8 col-md-8 col-sm-12 mix all dresses bags ${index % 2 == 0 ? feed.Chave == this.state.chaveFocus ? "par focusLight" : "par " : feed.Chave == this.state.chaveFocus ? "impar focusDark" : "impar"}`}>
                                            <div className="row deleteMargin alignCenter">
                                                <div className=" col-1 text-left" style={{ overflowWrap: 'anywhere' }}>
                                                    <p>{feed.Chave}</p>
                                                </div>
                                                <div className="col-3 text-left">
                                                    <p>{feed.pessoaNome}</p>
                                                </div>
                                                <div className="col-2 text-left">
                                                    <p>{moment(feed.Vencimento).format('DD/MM/YYYY')}</p>
                                                </div>
                                                <div style={{ overflowWrap: 'anywhere' }} className="col-2 text-left">
                                                    <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(feed.ValorBRL)}</p>
                                                </div>
                                                <div style={{ overflowWrap: 'anywhere' }} className="col-2 text-left">
                                                    <p>R$ {new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(feed.SaldoBRL)}</p>
                                                </div>
                                                <div className="col-2  text-left  mobileajuster4 icones">
                                                    <div className='iconelixo giveMargin' type='button'>
                                                        <Link to={{ pathname: `/financeiro/addconta/0`, state: { conta: {}, tipo: 0, to: 'contasreceber' } }}>
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </Link>
                                                    </div>
                                                    <div className='iconelixo giveMargin' type='button'>
                                                        <Link to={{ pathname: `/financeiro/addconta/${feed.Chave}`, state: { conta: { ...feed }, to: 'contasreceber' } }}>
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </Link>
                                                    </div>
                                                    <div className='iconelixo giveMargin' type='button'
                                                        title='Receber conta'
                                                        onClick={() => this.abrirRecebimento(feed)}>
                                                        <FontAwesomeIcon icon={faDollarSign} />
                                                    </div>
                                                    {this.state.acessosPermissoes.filter((e) => { if (e.acessoAcao == 'CONTAS_ABERTAS') { return e } }).map((e) => e.permissaoDeleta)[0] == 1 &&
                                                        <div type='button' className='iconelixo' onClick={(a) => this.deleteConta(feed.Chave, feed.pessoaNome)}>
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </div>
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-0 col-0"></div>
                                    </div>
                                ))}
                                {this.state.contas.filter(this.filtrarPesquisa)[this.state.load] &&
                                    <div className='loadMoreDiv'>
                                        <div className='loadMore' onClick={() => { this.setState({ load: this.state.load + 100 }) }}>Carregar Mais...</div>
                                    </div>
                                }
                                <br />
                            </div>
                        </div>
                    }
                </div>
                <Rodape />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        user: user,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(ContasReceber)